import { useQuery } from '@tanstack/react-query';

import { $api } from '../service';
import { getThereDirection, globalConst, IThereDirection } from '..';

export const useThereDirection = () => {
  const { data, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.GET_THERE_DIRECTION],
    queryFn: getThereDirection
  });

  return { ...data, ...args };
};

export const useDirection = (id?: number) => {
  const { data: direction, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.GET_DIRECTION, id],
    queryFn: async () => {
      const response = await $api.get<IThereDirection>('/direction', {
        params: { id }
      });

      return response.data;
    },
    enabled: !!id
  });

  return { direction, ...args };
};
